export default "__VITE_ASSET__DtlrBuJ6__"